export default "__VITE_ASSET__Co$np8CS__"